import App from './modules/app'

// window.lazySizesConfig = window.lazySizesConfig || {};
// lazySizesConfig.lazyClass = 'lazy';
// lazySizesConfig.loadingClass = 'lazyloading';
// lazySizesConfig.loadedClass = 'lazyloaded';
// lazySizesConfig.loadMode = 1;
// lazySizesConfig.preloadAfterLoad = true

// import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
// import 'lazysizes/plugins/object-fit/ls.object-fit'
// import 'lazysizes/plugins/respimg/ls.respimg'
// import 'lazysizes'

const modules = [
  // require('./modules/tabs.js'),
  // require('./modules/register.js'),
  // require('./modules/auto.js'),
  // require('./modules/columns.js'),
  require('./modules/carousel.js')
  // require('./modules/story.js'),
  // require('./modules/homepage.js'),
  // require('./modules/productslider.js'),
  // require('./modules/product.js'),
  // require('./modules/about.js'),
  // require('./modules/contact.js')
];

document.addEventListener('DOMContentLoaded', event => {


});



window.addEventListener("load", function(event) {

  var app = new App()
  modules.forEach(m => m.init());

    setTimeout(() => {
      $('html').addClass('initialized');
      $('html').removeClass('is-loading');

      if(typeof(Event) === 'function') {
        var event = new Event('resize');
      }
      else{
        var event = document.createEvent('Event');
        event.initEvent('resize', true, true);
      }
      window.dispatchEvent(event);

    }, 100);


});
